export function boothSectionLabel(label = '') {
  const normalized = label.trim().toLowerCase();
  if (normalized === 'intro') return 'Intro';
  if (normalized === 'hook' || normalized === 'chorus') return 'Hook';
  if (normalized === 'verse 2') return 'Verse 2';
  if (normalized === 'verse 3') return 'Verse 3';
  if (normalized === 'bridge') return 'Bridge';
  if (normalized === 'outro') return 'Outro';
  return 'Verse 1';
}
